export default "__VITE_ASSET__Dix9aWDc__"